import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CounterBadge from '@/components/micro/CounterBadge.vue'

interface Option {
  optValue: string
  optLabel?: string
  optIcon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickAction',
  props: {
    actionKey: {},
    icon: {},
    tooltip: { default: '' },
    theme: {},
    counter: {},
    options: {},
    disabled: { type: Boolean }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function handleMainTrigger() {
  if (props.options) return

  emit('action', props.actionKey)
}

function handleOptionClick(opt: Option) {
  emit('action', opt.optValue)
}

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!
  const _component_sword_tooltip = _resolveComponent("sword-tooltip")!
  const _component_sword_list = _resolveComponent("sword-list")!
  const _component_sword_popover_wuk = _resolveComponent("sword-popover-wuk")!
  const _directive_close_popper = _resolveDirective("close-popper")!

  return (_openBlock(), _createBlock(_component_sword_popover_wuk, {
    class: "relative inline-block",
    distance: 10,
    disabled: !__props.options,
    placement: "bottom-end"
  }, {
    default: _withCtx(({ shown }) => [
      _createVNode(_component_sword_tooltip, null, {
        tooltip: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(__props.tooltip)), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_sword_button_wuk, {
            icon: __props.icon,
            theme: __props.theme ?? (shown ? 'tertiary' : 'white'),
            disabled: __props.disabled,
            round: "",
            "data-ui-action": __props.actionKey,
            "aria-label": `click to ${_ctx.$t(__props.tooltip)}`,
            onClickNative: handleMainTrigger
          }, null, 8, ["icon", "theme", "disabled", "data-ui-action", "aria-label"]),
          _createVNode(CounterBadge, { value: __props.counter }, null, 8, ["value"])
        ], undefined, true),
        _: 2
      }, 1024)
    ]),
    content: _withCtx(() => [
      _withDirectives(_createVNode(_component_sword_list, {
        key: "send-link-options",
        class: "w-[17.5rem] py-4",
        options: __props.options,
        "align-left": "",
        onClick: handleOptionClick
      }, null, 8, ["options"]), [
        [_directive_close_popper]
      ])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})